<template>
  <div class="user-data-menu">
    <span class="user"><b-icon icon="person-fill"></b-icon> {{userData.title}} {{userData.fname}} {{userData.lname}}</span>
    <span class="user">{{userData.name}}</span>
    <span v-for="(route, index) in menu" :key="index">
      <span>
        <router-link :to="{name:route.routeName}" class="user">
          <b-icon :icon="route.icon"></b-icon>
          {{route.label}}
        </router-link>
      </span>
    </span>
  </div>
</template>

<script>

import authMixin from 'b2b-common/mixins/auth'
import { secondary } from '../nav'

export default {
  name: 'userDataMenu',
  mixins: [authMixin],
  data () {
    return {
      menu: secondary
    }
  }
}
</script>

<style lang="scss">
  .user-data-menu .user {
    font-size:.8rem;
    color: #00416b;
    border-right: 1px solid #c2e6fa;
    margin-left:10px;
    padding-right:10px;
  }
  .user-data-menu .user:last-child {
    border-right: none;
  }
  a.user {
    text-decoration: none;
    color:#00416b;
  }
</style>
